/** Temas visuales para el modal de feedback al responder un quiz. */

export const QUIZ_FEEDBACK_THEMES = {
	classic: {
		id: "classic",
		label: "Clásico",
		description: "Tarjeta limpia: verde si aciertas, rojo si fallas.",
	},
	neon: {
		id: "neon",
		label: "Cyber glitch",
		description: "Neón rosa/cian sobre fondo oscuro, con textos claros y legibles.",
	},
	minimal: {
		id: "minimal",
		label: "Papel editorial",
		description: "Serif, crema y líneas finas. Sin iconos llamativos.",
	},
	playful: {
		id: "playful",
		label: "Carnaval",
		description: "Burbujas, confeti y tipografía juguetona.",
	},
	retro: {
		id: "retro",
		label: "Terminal retro",
		description: "Fósforo verde, cursor parpadeante y bloques ASCII.",
	},
	glass: {
		id: "glass",
		label: "Azul nocturno",
		description: "Como el ER azul: profundo, hielo y brillo eléctrico.",
	},
	cinematic: {
		id: "cinematic",
		label: "Caso clínico",
		description: "Informe médico, teal institucional y alertas clínicas.",
	},
	clinicalFormal: {
		id: "clinicalFormal",
		label: "Caso clínico formal",
		description: "Oswald y Montserrat; verde #10b981 y lima #cbff97. Más grande y sobrio.",
	},
	comic: {
		id: "comic",
		label: "Cómic POW",
		description: "Viñeta con halftone, onomatopeyas y contorno grueso.",
	},
	horror: {
		id: "horror",
		label: "Terror gótico",
		description: "Oscuro, sangre y tipografía inquietante.",
	},
	gold: {
		id: "gold",
		label: "Trofeo dorado",
		description: "Negro y oro con brillo de logro premium.",
	},
	sticky: {
		id: "sticky",
		label: "Post-it",
		description: "Nota adhesiva amarilla, inclinada y manuscrita.",
	},
	corporate: {
		id: "corporate",
		label: "Corporativo",
		description: "Azul marino, blanco y tono profesional sobrio.",
	},
	executive: {
		id: "executive",
		label: "Ejecutivo",
		description: "Cabecera oscura, plata y estética de sala de juntas.",
	},
	institutional: {
		id: "institutional",
		label: "Institucional",
		description: "Documento oficial, grises y sello de validación.",
	},
	academic: {
		id: "academic",
		label: "Académico",
		description: "Burgundy y crema, estilo universitario formal.",
	},
};

export const QUIZ_FEEDBACK_THEME_IDS = [
	"corporate",
	"executive",
	"institutional",
	"academic",
	"classic",
	"minimal",
	"cinematic",
	"clinicalFormal",
	"glass",
	"neon",
	"playful",
	"retro",
	"comic",
	"horror",
	"gold",
	"sticky",
];

export function resolveQuizFeedbackThemeId(raw) {
	const id = String(raw || "classic").trim();
	return QUIZ_FEEDBACK_THEMES[id] ? id : "classic";
}

export function getQuizFeedbackTheme(id) {
	return QUIZ_FEEDBACK_THEMES[resolveQuizFeedbackThemeId(id)];
}

/** Tema del quiz: override por elemento o valor por defecto del escape room. */
export function resolveQuizFeedbackThemeForElement(element, escapeRoomDefault) {
	return resolveQuizFeedbackThemeId(element?.content?.quizFeedbackTheme || escapeRoomDefault || "classic");
}
